export const SCREEN_ORIENTATIONS = {
  LANDSCAPE: 1,
  PORTRAIT: 2,
}
